import React, { useState, useEffect } from 'react';
import { BarChart2, Clock, Users, MessageCircle } from 'lucide-react';
import api from '../services/api';
import '../styles/AdminComponents.css';

// remocao auto-close + CSAT — 2026-05-29 (incidente 2026-05-27)
// Secao CSAT removida: backend nao expoe mais /dashboard/csat e o fluxo
// de avaliacao foi desativado. Mantemos apenas as metricas operacionais.
function MetricsDashboard() {
  const [metrics, setMetrics] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetch = async () => {
    try {
      const m = await api.get('/dashboard/metrics');
      setMetrics(m.data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(() => {
    fetch();
    const interval = setInterval(fetch, 15000);
    return () => clearInterval(interval);
  }, []);

  if (loading) return <div className="admin-page">Carregando...</div>;
  if (!metrics) return <div className="admin-page">Sem dados</div>;

  const formatSeconds = (s) => {
    if (!s) return '-';
    const m = Math.floor(s / 60), r = Math.floor(s % 60);
    return `${m}m ${r}s`;
  };

  return (
    <div className="admin-page">
      <h2><BarChart2 size={22}/> Dashboard de Atendimento</h2>
      <p className="muted">Visão em tempo real (atualiza a cada 15s)</p>

      <div className="metric-cards">
        <div className="metric-card">
          <h3>Aguardando</h3>
          <p className="metric-value" style={{color: '#FF9800'}}>{metrics.ticketsByStatus?.pending || 0}</p>
        </div>
        <div className="metric-card">
          <h3>Em Atendimento</h3>
          <p className="metric-value" style={{color: '#4CAF50'}}>{metrics.ticketsByStatus?.open || 0}</p>
        </div>
        <div className="metric-card">
          <h3>Resolvidos</h3>
          <p className="metric-value" style={{color: '#9e9e9e'}}>{metrics.ticketsByStatus?.closed || 0}</p>
        </div>
        <div className="metric-card">
          <h3><Clock size={16}/> TME (Tempo Médio de Espera)</h3>
          <p className="metric-value">{formatSeconds(metrics.avgWaitTime)}</p>
        </div>
        <div className="metric-card">
          <h3><Clock size={16}/> TMA (Tempo Médio de Atendimento)</h3>
          <p className="metric-value">{formatSeconds(metrics.avgHandleTime)}</p>
        </div>
        <div className="metric-card">
          <h3><MessageCircle size={16}/> Mensagens Hoje</h3>
          <p className="metric-value">{metrics.messagesToday || 0}</p>
        </div>
        <div className="metric-card">
          <h3>Conversas Hoje</h3>
          <p className="metric-value">{metrics.conversationsToday || 0}</p>
        </div>
      </div>

      <div className="metric-section">
        <h3><Users size={18}/> Por Departamento</h3>
        <table className="admin-table">
          <thead><tr><th>Departamento</th><th>Tickets</th></tr></thead>
          <tbody>
            {(metrics.ticketsByDepartment || []).map((d, i) => (
              <tr key={i}><td>{d.name || d.department || 'Sem fila'}</td><td>{d.count}</td></tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="metric-section">
        <h3><Users size={18}/> Por Atendente</h3>
        <table className="admin-table">
          <thead><tr><th>Atendente</th><th>Atendimentos</th></tr></thead>
          <tbody>
            {(metrics.ticketsByAgent || []).map((a, i) => (
              <tr key={i}><td>{a.name || a.agent || 'Sem atendente'}</td><td>{a.count}</td></tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default MetricsDashboard;
